import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import * as translationService from '../services/translationService'
import { Hero, DisplayText, TextContainer, ResourceList, PropertyBar } from '../components'
import * as routeService from '../services/routeService'

// const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

const externalUrls = {
  nl_BE: {
    properties: 'https://www.dewaele.com/nl/te-huur',
    propertiesMail: 'https://www.dewaele.com/nl/zoekopdracht-bewaren',
  },
  en_US: {
    properties: 'https://www.dewaele.com/en/to-let',
    propertiesMail: 'https://www.dewaele.com/en/dewaele-will-search-for-you',
  },
  fr_FR: {
    properties: 'https://www.dewaele.com/fr/louer',
    propertiesMail: 'https://www.dewaele.com/fr/sauvegarder-la-recherche',
  },
}

const mapStateToProps = ({ FlowReducer, AuthReducer }) => {
  const { user } = AuthReducer
  const { application, property, step } = FlowReducer
  return {
    user,
    application,
    property,
    step,
  }
}

const openNewTabUrl = url => {
  window.open(url, '_blank')
}

function SentView(props) {
  const { user, application, property, step } = props
  const isBroker = !!user && user.activeAccountId !== user.personalAccountId
  const { firstname } = application.contacts ? application.contacts[0] : ''

  let items = []

  if (!isBroker) {
    items.push({
      content: translationService.sentProfileRequests(step),
      action: {
        content: translationService.sentProfileRequestsActions(step),
        fullWidth: true,
        primary: true,
        onClick: () => {
          routeService.goToProfilePage('aanvragen')
        },
      },
    })
  }

  if (property && property.broker && property.broker.id === 2) {
    items = items.concat([
      {
        content: translationService.t('intake.sent.properties'),
        action: {
          content: translationService.t('intake.sent.properties.action'),
          fullWidth: true,
          primary: true,
          onClick: () => openNewTabUrl(externalUrls[translationService.currentLocale()]['properties']),
        },
      },
      {
        content: translationService.t('intake.sent.mail.properties'),
        action: {
          content: translationService.t('intake.sent.mail.properties.action'),
          fullWidth: true,
          primary: true,
          onClick: () => openNewTabUrl(externalUrls[translationService.currentLocale()]['propertiesMail']),
        },
      },
    ])
  }

  const renderItem = item => {
    return (
      <ResourceList.Item actions={item.action}>
        <p>{item.content}</p>
      </ResourceList.Item>
    )
  }
  return (
    <div>
      {property && <PropertyBar property={property} />}
      <Hero>
        <TextContainer>
          <DisplayText>{translationService.sentTitle(firstname)}</DisplayText>
          <DisplayText size="small">
            {translationService.sentIntro(step, property.broker ? property.broker.name : undefined)}
          </DisplayText>
        </TextContainer>
      </Hero>
      <ResourceList equalWidthActions items={items} renderItem={renderItem} />
    </div>
  )
}

SentView.propTypes = {
  user: PropTypes.any,
  application: PropTypes.any,
  property: PropTypes.any,
  step: PropTypes.any,
}

export default compose(connect(mapStateToProps))(SentView)



// WEBPACK FOOTER //
// ./src/views/SentView.js